import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import HTMLReactParser from 'html-react-parser';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "@StarberryUtils"
import { useLocation } from "@reach/router";
import BandSection from '../../BandSection/BandSection';

import { GetURL } from "../../common/site/functions";
import ShanlyImg from "../../../images/Shanly-main.png";

function PropertyManagement(props) {
    const { pathname } = useLocation();
    var isHome = pathname === "/" ;
    return (
        <div className="property-management">
        <Container>
            <Row>
            {props.data && props.data.map((module, i) => {
                let url = ''
                if(module.CTA_Link) {
                    url = GetURL(module.CTA_Link._id)
                }
                return (
                    <>
                    {!isHome &&
                    <Col xl={6} className="mb-4">
                        <div className={`block ${i == 1 ? "property-bg-tag" : ""}`}>
                            <h2>{module?.Title && module.Title}</h2>
                            <h4>{module?.Sub_Title && module.Sub_Title}</h4>
                            {module.CTA_Label &&
                            <div className="buttons">
                                <Link to={`/${url}`} className="btn btn-primary">
                                    {module.CTA_Label}
                                </Link>
                            </div>
                            }
                            {module.Content &&
                            <div className="content pl-lg-3 pl-0">
                                {HTMLReactParser(module.Content.replace(/\n/g,'<br />'))}
                            </div>}
                        </div>
                    </Col>
                    }
                    {isHome &&
                       <BandSection module={module} image={ShanlyImg} />                  
                    }
                    </>
                )
            })}
            </Row>
        </Container>
        </div>
    )
}

export default PropertyManagement;